import { AnalyticsAdapter } from '@lifeway/frontend-analytics';
import { sendGtagPageView } from '../api/sendGtagPageView';

function getGtmAppId(): string {
  return (window.config?.GTM_APP_ID as string) || '';
}

function initGtag(): void {
  const gtmAppId = getGtmAppId();

  // Prevent multiple calls to initGtag
  if (!gtmAppId || typeof window.gtag === 'function') {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmAppId}`;
  document.head.appendChild(script);

  const dataLayer = window.dataLayer ?? [];
  window.dataLayer = dataLayer;

  const gtag: (...args: unknown[]) => void = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments);
  };
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', gtmAppId, { send_page_view: false });
}

export class GtagAdapter implements AnalyticsAdapter {
  constructor() {
    initGtag();
  }

  public viewPage(): void {
    sendGtagPageView();
  }

  public emit(): Promise<unknown> {
    return Promise.resolve();
  }
  public log(): void {}
  public unloadPage(): void {}
  public updatePage(): void {}
  public anonymize(): Promise<void> {
    return Promise.resolve();
  }
  public identify(): Promise<void> {
    return Promise.resolve();
  }
  public addSessionContext(): void {}
}
